import Input from 'components/common/form/input/Input';
import Select from 'components/common/form/select/Select';
import React from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { perferenceOptions } from './config';

function CandidateAvailabilityForm() {
  return (
    <>
      <p>
        Please specify when you will be available to start work after receiving
        a job offer. Choose 'Immediately' or 'Within 1 week.' Additionally,
        indicate your preferred work schedule by selecting either 'Full-time'
        for a full-time position or 'Part-time' for a part-time role.
      </p>
      <Row className="g-5">
        <Col xs={12} xl={7}>
          <FormGroup className="text-start">
            <FormLabel htmlFor="jobPreference">Preference</FormLabel>
            <Select
              name="jobPreference"
              id="jobPreference"
              options={perferenceOptions}
            />
          </FormGroup>
        </Col>
        <Col xs={12} xl={5}>
          <FormGroup className="text-start">
            <FormLabel htmlFor="startWork">
              Availability to Start Work (In Week)
            </FormLabel>
            <Input name="startWork" id="startWork" />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
}

export default CandidateAvailabilityForm;
